import React, {useMemo} from "react";
import {Box, IconButton, InputAdornment, MenuItem, TextField, Tooltip,} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const ResponsiveSelect = ({
                              label,
                              value,
                              onChange,
                              onClear,
                              options = [],
                              data,
                              dataKey,
                              t,
                              isSmall = false,
                              fullWidth = false,
                              maxWidth: maxWidthProp,
                              error = false,
                              helperText = "",
                          }) => {

    const computedOptions = useMemo(() => {
        if (data && dataKey && data[dataKey]) {
            const list = data[dataKey] || [];
            return [
                ...(fullWidth ? [] : [{value: "", label: t?.("common.all") || "All"}]),
                ...list.map((item) => ({
                    value: item.id,
                    label: item.name,
                })),
            ];
        }
        return options;
    }, [data, dataKey, options, t]);

    return (
        <TextField
            select
            size={fullWidth ? "medium" : "small"}
            variant="outlined"
            value={value}
            onChange={onChange}
            label={label}
            error={error}
            helperText={helperText}
            sx={{
                minWidth: fullWidth ? "100%" : isSmall ? "100%" : 180,
                maxWidth: fullWidth ? "100%" : (maxWidthProp || 180),
                "& .MuiSelect-select": {
                    pr: value ? 5 : 3,
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    display: "block",
                },
            }}
            SelectProps={{
                renderValue: (selected) => {
                    const item = computedOptions.find((o) => o.value === selected);
                    const label = item ? item.label : "";
                    return (
                        <Tooltip title={label} arrow>
                            <Box
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {label}
                            </Box>
                        </Tooltip>
                    );
                },
            }}
            InputProps={{
                endAdornment:
                    value && onClear ? (
                        <InputAdornment
                            position="end"
                            sx={{mr: 4, position: "absolute", right: 10}}
                        >
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onClear();
                                }}
                                edge="end"
                                sx={{
                                    p: 0,
                                    mr: -1,
                                    "&:hover": {color: "error.main"},
                                }}
                            >
                                <ClearIcon fontSize="small"/>
                            </IconButton>
                        </InputAdornment>
                    ) : null,
            }}
        >
            {computedOptions
                .filter((opt) => !(fullWidth && opt.value === ""))
                .map((opt) => (

                    <MenuItem key={opt.value} value={opt.value} sx={{maxWidth: fullWidth ? 550 : (maxWidthProp || 180)}}>
                        <Tooltip title={opt.label} placement="right" arrow>
                            <Box
                                component="span"
                                sx={{
                                    display: "block",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",


                                }}
                            >
                                {opt.label}
                            </Box>
                        </Tooltip>
                    </MenuItem>
                ))}
        </TextField>
    );
};

export default ResponsiveSelect;
